import moment from 'moment';

/** UK display format used by the vulnerability tables; empty end dates show as "-". */
export const formatVulnerabilityDate = (value: string | null | undefined): string =>
  value ? moment(value).format('DD/MM/YYYY') : '-';

/** ISO date (yyyy-mm-dd) for native date inputs and the GraphQL Date scalar. */
export const toIsoDate = (value: string | null | undefined): string =>
  value ? moment(value).format('YYYY-MM-DD') : '';

export const todayIsoDate = (): string => moment().format('YYYY-MM-DD');

/**
 * Draft rows in the SFP tube stop get their id on the client so that every
 * autosave of the table is idempotent on the backend instead of creating
 * duplicates. A v4-shaped id is enough; it only needs to be unique per review.
 */
export const newDraftId = (): string =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    // The variant nibble of a v4 id is 8, 9, a or b.
    const v = c === 'x' ? r : 8 + (r % 4);
    return v.toString(16);
  });
